import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthentificationService } from './authentification/authentification.service';
import { RolesService } from './authentification/roles.service';
import { ParametresService } from './core/parametres.service';
import { SpinnerService } from './core/spinner.service';
import { ModeRenduService } from './saisie/mode-rendu/mode-rendu.service';

@Component({
  selector: 'bis-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  enDev = environment.dev;
  enProd = environment.production;
  
  constructor (private parametresService: ParametresService,
    public spinner: SpinnerService,
    public modeRenduService: ModeRenduService,
    public AUTH: AuthentificationService,
    private activatedRoute: ActivatedRoute,
    public ROLES: RolesService
    ) {
      setTimeout(() => {
        this.titreComplet$ = parametresService.getAnnee$().pipe(map(annee => this.titre + ' ' + annee));
        this.titreCompletRaccourci$ = parametresService.getAnnee$().pipe(map(annee => this.titreRaccourci + ' ' + annee));
        this.dateFinEnquete$ = parametresService.getDateFinCampagne$().pipe(map(dateFinEnquete => dateFinEnquete));
      }, 1000);

    activatedRoute.queryParams.subscribe(param => {
      if (param.debug && param.debug === 'true') {
        environment.dev = true;
        environment.recette = true;
      }
    });
  }
  private titre = 'Enquête ' + environment.enquete;
  private titreRaccourci = 'Enquête ' + environment.enqueteRaccourci;
  private titreComplet$: Observable<string>;
  private titreCompletRaccourci$: Observable<string>;
  private dateFinEnquete$: Observable<string>;
  /**
  * Retourne le titre sous forme d’observable
  * composé d’enquête suivi du nom de l’enquête et enfin de la date de l’enquête en cours.
  */
  public getTitreComplet$(): Observable<string> {
    return this.titreComplet$;
  }
  public getTitreCompletRaccourci$(): Observable<string> {
    return this.titreCompletRaccourci$;
  }
  /**
  * Retourne la date de fin enquete sous forme d’observable
  */
  public getDateFinEnquete$(): Observable<string> {
    return this.dateFinEnquete$;
  }
  /**
   * Retourne le titre composé d’enquête suivi du nom de l’enquête
   */
  public getTitre(): string {
    return this.titre;
  }

  public getVersion(): string {
    return environment.version;
  }

  public initializeSession() {
    this.AUTH.login();
  }
}
